import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    signIn,
    confirmSignIn, 
    getCurrentUser,
    signUp,
    confirmSignUp
} from '@aws-amplify/auth';
import logoImg from '../logo.png'; 
import './LoginModal.css'; 

const LoginModal = ({ isOpen, onClose }) => {
    // Estados principales
    const [view, setView] = useState('login'); // 'login', 'signup', 'confirm'
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState(''); // Código de verificación
    const [error, setError] = useState('');
    
    // Estados para nueva contraseña (Flujo New Password Required)
    const [requiresNewPassword, setRequiresNewPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [cognitoUser, setCognitoUser] = useState(null);

    const navigate = useNavigate();

    if (!isOpen) return null;
    
    const checkUserAndRedirect = async () => { 
        try {
            await getCurrentUser();
            onClose(); 
            navigate('/profile'); 
            window.location.reload(); 
        } catch (err) {
            onClose();
            navigate('/profile'); 
            window.location.reload(); 
        }
    };

    // FUNCIÓN: LOGIN
    const handleSignIn = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const user = await signIn({ username, password });
            if (user.nextStep.signInStep === 'NEW_PASSWORD_REQUIRED') {
                setCognitoUser(user);
                setRequiresNewPassword(true);
                return;
            }
            await checkUserAndRedirect();
        } catch (err) {
            setError(err.message || 'Error al iniciar sesión.');
        }
    };

    // FUNCIÓN: REGISTRO
    const handleSignUp = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signUp({
                username,
                password,
                options: { userAttributes: { email: username } }
            });
            setView('confirm'); // Pasamos a confirmar código
        } catch (err) {
            setError(err.message || 'Error al registrarse.');
        }
    };

    // FUNCIÓN: CONFIRMAR CÓDIGO
    const handleConfirmSignUp = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await confirmSignUp({ username, confirmationCode: code });
            alert("¡Cuenta verificada! Ahora puedes iniciar sesión.");
            setView('login');
        } catch (err) {
            setError(err.message || 'Código incorrecto.');
        }
    };

    const handleNewPasswordSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await confirmSignIn({ 
                user: cognitoUser, 
                challengeResponse: newPassword
            });
            await checkUserAndRedirect();
        } catch (err) {
            setError(err.message || 'Error al cambiar contraseña.');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close-button" onClick={onClose}>&times;</button>
                
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <img src={logoImg} alt="Logo Scarvaci" style={{ height: '70px' }} />
                </div>

                {requiresNewPassword ? (
                    <>
                        <h2>Nueva Contraseña</h2>
                        <form onSubmit={handleNewPasswordSubmit}>
                            <input type="password" placeholder="Nueva Contraseña" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                            {error && <p className="error-message">{error}</p>}
                            <button type="submit" className="cta-button">Confirmar</button>
                        </form>
                    </>
                ) : view === 'confirm' ? (
                    <>
                        <h2>Verificar Correo</h2>
                        <p style={{fontSize:'13px', color:'#777'}}>Ingresa el código enviado a tu email.</p>
                        <form onSubmit={handleConfirmSignUp}>
                            <input type="text" placeholder="Código de 6 dígitos" value={code} onChange={(e) => setCode(e.target.value)} required />
                            {error && <p className="error-message">{error}</p>}
                            <button type="submit" className="cta-button">Verificar Cuenta</button>
                        </form>
                    </>
                ) : (
                    <>
                        <h2>{view === 'login' ? 'Iniciar Sesión Cliente' : 'Crear Cuenta Nueva'}</h2>
                        <form onSubmit={view === 'login' ? handleSignIn : handleSignUp}>
                            <input type="email" placeholder="Correo electrónico" value={username} onChange={(e) => setUsername(e.target.value)} required />
                            <input type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required />
                            {error && <p className="error-message">{error}</p>}
                            <button type="submit" className="cta-button">
                                {view === 'login' ? 'Entrar a mi Cuenta' : 'Registrarme Ahora'}
                            </button>
                        </form>

                        <div style={{ textAlign: 'center', marginTop: '15px' }}>
                            <p style={{fontSize: '14px', color: '#555'}}>
                                {view === 'login' ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'} 
                                <span 
                                    onClick={() => setView(view === 'login' ? 'signup' : 'login')}
                                    style={{ color: '#D4AF37', cursor: 'pointer', fontWeight: 'bold', marginLeft: '5px' }}
                                >
                                    {view === 'login' ? 'Regístrate aquí' : 'Inicia Sesión'}
                                </span>
                            </p>
                        </div>
                    </>
                )}

<div style={{ textAlign: 'center', marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
    <button 
        onClick={() => {
            onClose();      // Cierra el cuadro
            navigate('/');  // Salta a la página principal
            window.scrollTo(0, 0); // Asegura que inicie arriba
        }} 
        style={{ 
            background: '#000', 
            color: '#D4AF37', 
            border: '1px solid #D4AF37', 
            padding: '10px 25px',
            borderRadius: '4px',
            cursor: 'pointer', 
            fontWeight: 'bold', 
            fontSize: '14px',
            width: '100%'
        }}
    >
        SALIR Y VOLVER AL INICIO
    </button>
</div>
            </div>
        </div>
    );
};

export default LoginModal;